var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import * as S from './styles';
export var Paper = forwardRef(function Paper(_a, ref) {
    var children = _a.children, className = _a.className, outlined = _a.outlined, inverted = _a.inverted, style = _a.style, rest = __rest(_a, ["children", "className", "outlined", "inverted", "style"]);
    var outlinedClassName = outlined ? 'outlined' : false;
    var invertedClassName = inverted ? 'inverted' : false;
    var rootClass = cx(className, outlinedClassName, invertedClassName);
    return (React.createElement(S.Paper, __assign({ ref: ref, className: rootClass, style: style }, rest), children));
});
Paper.defaultProps = {
    outlined: false,
    inverted: false
};
Paper.displayName = 'Paper';
export default Paper;
//# sourceMappingURL=Paper.js.map